(function(){
/* (v11) Cuenta atrás del hero hasta el lanzamiento: 13 oct 2026 00:00 hora peninsular (CEST, +02:00). Un tick por
   segundo alineado al reloj; sólo ruedan los dígitos que cambian (entra desde arriba y sale hacia abajo con desenfoque
   de movimiento, Web Animations, sin GSAP). Con reduced-motion cambian sin animación. aria-label con el resumen por
   minutos; al llegar a cero, «Ya disponible». */
var root=document.querySelector('.cd'); if(!root) return;
var T=Date.parse((window.WBL_PHASES && window.WBL_PHASES.launch) || '2026-10-13T09:00:00+02:00'), still=matchMedia('(prefers-reduced-motion: reduce)').matches;
var lbl=root.querySelector('.cd__lbl'), pills={}, aria='';
[].forEach.call(root.querySelectorAll('.cd__pill'),function(p){pills[p.dataset.u]=p;p.textContent='';});
var EASE={duration:520,easing:'cubic-bezier(.22,.7,.12,1)'};
var roll=function(slot,cur,ch){
  var nx=document.createElement('i'); nx.textContent=ch; slot.appendChild(nx);
  cur.animate([{transform:'translateY(0)',filter:'blur(0)',opacity:1},{transform:'translateY(90%)',filter:'blur(3px)',opacity:0}],EASE).onfinish=function(){cur.remove();};
  nx.animate([{transform:'translateY(-90%)',filter:'blur(3px)',opacity:0},{transform:'translateY(0)',filter:'blur(0)',opacity:1}],EASE);
};
var set=function(p,str){
  while(p.children.length<str.length){var s=document.createElement('span');s.className='cd__d';s.appendChild(document.createElement('i'));p.insertBefore(s,p.firstChild);}
  while(p.children.length>str.length)p.removeChild(p.firstChild);
  for(var k=0;k<str.length;k++){
    var slot=p.children[k], cur=slot.lastElementChild, ch=str[k];
    if(cur.textContent===ch)continue;
    if(!cur.textContent||still||!cur.animate){cur.textContent=ch;continue;}
    roll(slot,cur,ch);
  }
};
var two=function(n){return (n<10?'0':'')+n;}, pl=function(n,a,b){return n+' '+(n===1?a:b);};
var tick=function(){
  var ms=Math.max(0,T-Date.now()), s=Math.floor(ms/1000);
  var d=Math.floor(s/86400), h=Math.floor(s%86400/3600), m=Math.floor(s%3600/60);
  set(pills.d,two(d)); set(pills.h,two(h)); set(pills.m,two(m)); set(pills.s,two(s%60));
  var a=ms?'Faltan '+pl(d,'día','días')+', '+pl(h,'hora','horas')+' y '+pl(m,'minuto','minutos')+' para el lanzamiento, el 13 de octubre':'Ya disponible';
  if(a!==aria){root.setAttribute('aria-label',a);aria=a;}
  if(!ms){if(lbl)lbl.textContent='Ya disponible';return;}
  setTimeout(tick,1000-Date.now()%1000+15);
};
tick();
})()
